function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_x0020_1"
}, /*#__PURE__*/React.createElement("metadata", {
  id: "CorelCorpID_0Corel-Layer"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M409.895 876.533l780.225 0c42.4016,0 80.7839,17.348 108.66,45.1996 27.874,27.8551 45.2339,66.2126 45.2339,108.581l0 172.073c0,3.53859 -0.113386,6.96497 -0.35315,10.5 -48.0697,-47.2052 -112.201,-73.402 -179.527,-73.402 -68.1426,0 -132.873,26.7862 -181.056,74.941 -38.7437,38.7095 -63.7819,88.2792 -71.9316,141.737l-158.263 0c-8.14843,-53.4579 -33.0721,-103.028 -71.9268,-141.737 -48.1914,-48.1548 -112.913,-74.941 -181.062,-74.941 -68.0315,0 -132.872,26.7862 -180.944,74.941 -18.0697,17.941 -33.0697,38.237 -44.7615,60.0721 -0.946064,-1.76929 -1.89095,-3.54331 -2.71772,-5.3126 -9.92245,-20.3008 -15.4725,-42.9579 -15.4725,-66.7985l0 -172.073c0,-42.3685 17.3634,-80.7249 45.2374,-108.581 27.8717,-27.8516 66.2564,-45.1996 108.658,-45.1996l0 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M1500.04 812.566l199.957 0c25.2732,0 48.3048,10.3866 64.9571,27.0272 16.6536,16.6382 27.0473,39.6532 27.0473,64.9099l0.0011811 259.881 0 67.0347 -52.0855 -42.3685 -320.072 -259.761 -11.8158 -9.68032 0 -15.1051c0,-25.2567 10.2815,-48.2717 26.9339,-64.9099 16.6536,-16.6406 39.6839,-27.0272 65.0764,-27.0272l0 0z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "958.746,707.058 1388.43,459.097 1411.81,445.643 1429.05,466.532 1724.56,824.369 1675.31,864.849 1653.94,838.886 1537.83,862.843 1401.42,667.165 1074.85,933.3 1034.57,883.853 1001.97,755.8 990.634,762.291 "
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M782.998 748.601l0 -175.733 82.2048 0 80.7875 175.733 -162.992 0zm-32.5973 0l-131.687 0c-21.4961,0 -40.7504,-7.43623 -54.45,-19.3559 -12.5197,-10.9772 -20.1969,-25.6099 -20.1969,-41.5418l0 -53.8193c0,-15.9319 7.67717,-30.6851 20.1969,-41.5418 13.6996,-11.9197 32.954,-19.474 54.45,-19.474l131.687 0 0 175.733zm333.304 146.695l-160.038 -347.685 -1.17992 -2.59725c-26.9292,-58.5355 -53.3823,-116.13 -127.795,-116.13l-279.442 0c-44.8831,0 -85.7481,18.4099 -115.274,47.9174 -29.6457,29.504 -47.9528,70.3382 -47.9528,115.187l0 185.407c0,44.8489 18.3071,85.6831 47.9528,115.186 29.5264,29.6268 70.3914,47.9185 115.273,47.9185l539.404 0 49.839 0 -20.7862 -45.2044z"
}), /*#__PURE__*/React.createElement("g", {
  id: "_225490576"
}, /*#__PURE__*/React.createElement("path", {
  id: "_225491536",
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M499.895 1171.46c61.8874,0 117.872,25.0252 158.382,65.5016 40.6264,40.4835 65.6717,96.5387 65.6717,158.269 0,61.8426 -25.0453,117.782 -65.6717,158.258 -40.5107,40.4847 -96.495,65.6245 -158.382,65.6245 -61.7705,0 -117.874,-25.1398 -158.385,-65.6245 -40.5095,-40.4764 -65.5501,-96.4158 -65.5501,-158.258 0,-61.7304 25.0406,-117.784 65.5501,-158.269 40.5118,-40.4764 96.6142,-65.5016 158.385,-65.5016l0 0zm0.0401575 116.815c28.4492,0 55.5485,11.2087 75.6827,31.3004 20.1414,20.0988 31.4055,47.2311 31.4055,75.6922 0,28.4811 -11.2524,55.5804 -31.4055,75.6898 -20.1343,20.0906 -47.2276,31.3418 -75.6827,31.3418 -28.4398,0 -55.5886,-11.2606 -75.7005,-31.3571 -20.126,-20.1118 -31.3477,-47.2193 -31.3477,-75.6745 0,-28.4362 11.2347,-55.578 31.3477,-75.6768 20.113,-20.0977 47.2666,-31.3158 75.7005,-31.3158z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_225490600",
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M499.935 1320.28c20.7402,0 39.5032,8.38701 53.08,21.952 13.6146,13.5673 22.0087,32.3528 22.0087,53.041 0,20.726 -8.3941,39.4737 -22.0087,53.0386 -13.5768,13.5673 -32.3398,21.9933 -53.08,21.9933 -20.7024,0 -39.5044,-8.42599 -53.0811,-21.9933 -13.5756,-13.565 -21.9673,-32.3126 -21.9673,-53.0386 0,-20.6882 8.39174,-39.4737 21.9673,-53.041 13.578,-13.565 32.3788,-21.952 53.0811,-21.952l0 0z"
})), /*#__PURE__*/React.createElement("g", {
  id: "_225490504"
}, /*#__PURE__*/React.createElement("path", {
  id: "_225491080",
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M1164.08 1171.46c61.8874,0 117.872,25.0252 158.382,65.5016 40.6264,40.4835 65.6717,96.5387 65.6717,158.269 0,61.8426 -25.0453,117.782 -65.6717,158.258 -40.5107,40.4847 -96.495,65.6245 -158.382,65.6245 -61.7705,0 -117.874,-25.1398 -158.385,-65.6245 -40.5095,-40.4764 -65.5501,-96.4158 -65.5501,-158.258 0,-61.7304 25.0406,-117.784 65.5501,-158.269 40.5118,-40.4764 96.6142,-65.5016 158.385,-65.5016l0 0zm0.0401575 116.815c28.4492,0 55.5485,11.2087 75.6827,31.3004 20.1414,20.0988 31.4055,47.2311 31.4055,75.6922 0,28.4811 -11.2524,55.5804 -31.4055,75.6898 -20.1343,20.0906 -47.2276,31.3418 -75.6827,31.3418 -28.4398,0 -55.5886,-11.2606 -75.7005,-31.3571 -20.126,-20.1118 -31.3477,-47.2193 -31.3477,-75.6745 0,-28.4362 11.2347,-55.578 31.3477,-75.6768 20.113,-20.0977 47.2666,-31.3158 75.7005,-31.3158z"
}), /*#__PURE__*/React.createElement("path", {
  id: "_225490960",
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M1164.12 1320.28c20.7402,0 39.5032,8.38701 53.08,21.952 13.6146,13.5673 22.0087,32.3528 22.0087,53.041 0,20.726 -8.3941,39.4737 -22.0087,53.0386 -13.5768,13.5673 -32.3398,21.9933 -53.08,21.9933 -20.7024,0 -39.5044,-8.42599 -53.0811,-21.9933 -13.5756,-13.565 -21.9673,-32.3126 -21.9673,-53.0386 0,-20.6882 8.39174,-39.4737 21.9673,-53.041 13.578,-13.565 32.3788,-21.952 53.0811,-21.952l0 0z"
})));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  width: 2048,
  height: 2048
});

var SvgEscavator = function SvgEscavator(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: "2048px",
    height: "2048px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2048 2048",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEscavator, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Escavator.2312913f.svg";
export { ForwardRef as ReactComponent };